import { useCachedQuery } from '../../hooks/useCachedQuery';

// Compromissos pessoais. Sem profissional selecionado a agenda lista todos;
// com filtro, só os do profissional — mesmo recorte dos bloqueios de agenda.
export function usePersonalEvents(professionalId) {
  const url = professionalId
    ? `/personal-events/professionals/${professionalId}`
    : '/personal-events';

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    personalEvents: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
